module.exports = __webpack_public_path__ + "bdfb0ee813903cab0d8e416362eff859.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/swastik-pareek.jpg
 ** module id = 427
 ** module chunks = 0
 **/